import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('login', {
        template: require('./login.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'Upload'
    ];

    function Ctrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        Upload
    ) {
        var vm = this;

        vm.data = {
            type: 'new_teacher'
        };

        vm.user = SessionService.getUser();
        vm.app = $stateParams.app;
        vm.specs = $stateParams.specs;
        vm.send_specs = send_specs;
        vm.app = 1;

        vm.border_tl = require('Images/bordertl.png');
        vm.border_tr = require('Images/bordertr.png');
        vm.border_bl = require('Images/borderbl.png');
        vm.border_br = require('Images/borderbr.png');
        vm.registered_img = require('Images/registered.png');


        if($stateParams.popup == '1'){
            logger.success('Succesfully created an account, Please log-in to proceed');
        }

        function proceed(){

            if(vm.app){
                $state.go('application-details', $stateParams);
            }else{
                window.location = '/#!/download_app';
            }
        }

        if(vm.user){

            if(vm.specs){

                setTimeout(()=>{
                    const specs = localStorage.getItem('specs');
                    console.log('data', specs);
                    vm.send_specs(specs);
                }, 100);

            }else{
                proceed();
            }
            
        }

        function send_specs(specs){

            var req = {
                method: 'PUT',
                body: { specs: specs }, 
                params: false, 
                hasFile: false, 
                route: { teacher: vm.user.id }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    proceed();
                });
        };

        vm.login = () => {

            var req = {
                method: 'POST',
                body: vm.data, 
                params: false, 
                hasFile: false, 
                route: { auth: 'sign-in-app' }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    var data = response.data.data;
                    // console.log('kbjhsdfag',data)
                    SessionService.saveUser(data);
                    if(vm.app){
                        $state.go('application-details', $stateParams);
                    }else{
                        window.location = '/#!/download_app';
                    }
        
                })
                .catch(function(response) {
                    if (response.status == 400) {
                        var error = response.data.errors[0];

                        var context = error.message;
                        logger.error(context);

                    }
                });
        }

        // 3-step password reset: 1 = email, 2 = emailed code, 3 = new password
        vm.forgot_step = 1;

        vm.open_forgot = () => {
            vm.forgot = true;
            vm.forgot_step = 1;
            vm.forgot_email = vm.data.username;
            vm.forgot_code = '';
            vm.forgot_token = null;
            vm.new_password = '';
            vm.confirm_password = '';
        }

        vm.close_forgot = () => {
            vm.forgot = false;
            vm.forgot_done = false;
        }

        function reset_error(response, fallback){
            if (response.status == 400 && response.data && response.data.errors) {
                var error = response.data.errors[0];

                var context = error.message;
                logger.error(context);
            }else{
                logger.error(fallback);
            }
        }

        // step 1 - email us the address, backend mails a 6 digit code
        vm.send_reset_code = () => {

            if(!vm.forgot_email || vm.resetting) return;

            vm.resetting = true;

            var req = {
                method: 'POST',
                body: { email: vm.forgot_email },
                params: false,
                hasFile: false,
                route: { auth: 'password_reset_request' },
            };

            QueryService.query(req)
                .then(function(response) {
                    logger.success('A 6 digit code has been sent to ' + vm.forgot_email);
                    vm.forgot_code = '';
                    vm.forgot_step = 2;
                })
                .catch(function(response) {
                    reset_error(response, 'Could not send a reset code to this email');
                })
                .finally(function() {
                    vm.resetting = false;
                });
        }

        // step 2 - trade the code for a one time token
        vm.verify_reset_code = () => {

            if(!vm.forgot_code || vm.resetting) return;

            vm.resetting = true;

            var req = {
                method: 'POST',
                body: { email: vm.forgot_email, code: String(vm.forgot_code).trim() },
                params: false,
                hasFile: false,
                route: { auth: 'password_reset_verify' },
            };

            QueryService.query(req)
                .then(function(response) {
                    vm.forgot_token = response.data.data.token;
                    vm.new_password = '';
                    vm.confirm_password = '';
                    vm.forgot_step = 3;
                })
                .catch(function(response) {
                    reset_error(response, 'Could not verify this code');
                })
                .finally(function() {
                    vm.resetting = false;
                });
        }

        // step 3 - set the new password using the token from step 2
        vm.confirm_new_password = () => {

            if(vm.cannot_confirm_password() || vm.resetting) return;

            vm.resetting = true;

            var req = {
                method: 'POST',
                body: {
                    token: vm.forgot_token,
                    password: vm.new_password,
                    password_confirmation: vm.confirm_password
                },
                params: false,
                hasFile: false,
                route: { auth: 'password_reset_confirm' },
            };

            QueryService.query(req)
                .then(function(response) {
                    logger.success('Your password has been changed. Please sign in');
                    vm.forgot_done = true;
                    vm.forgot_token = null;
                })
                .catch(function(response) {
                    reset_error(response, 'Could not change your password');
                })
                .finally(function() {
                    vm.resetting = false;
                });
        }

        vm.cannot_confirm_password = () => {

            if(!vm.new_password || vm.new_password.length < 6){
                return true;
            }

            if(vm.new_password !== vm.confirm_password){
                return 'mismatch';
            }

            return false;
        }

        vm.register = () => {

            var req = {
                method: 'POST',
                body: vm.data, 
                params: false, 
                hasFile: false, 
                route: { teacher: 'register-email' }, 
            };

            console.log(vm.data);

            QueryService.query(req)
                .then(function(response) {
                    console.log(response.data.errors)
                    if(response.data.errors && response.data.errors['DUPLICATE_FILE']){
                        logger.error('This email is already registered in our system. Please check your email for further details. ');
                    }else{
                        vm.registered = true;
                    }
                })
                .catch(function(response) {
                    if (response.status == 400) {
                        var error = response.data.errors[0];

                        var context = error.message;
                        logger.error(context);
                    }
                });
        }

        vm.can_apply = 1;
        vm.can_apply = 0;
        check_now();
        function check_now(){

            // var request = {
            //     method: 'GET',
            //     params: false,
            //     hasFile: false,
            //     route: { settings_application_dates: 'now' }
            // };

            // QueryService.query(request)
            //     .then(
            //         function(response) {
            //             const d = response.data.data.items;
            //             vm.can_apply = d.length != 0;

                        

            //         },
            //         function(error) {
            //         }
            //     )
            //     .finally(function() {
            //         vm.loaded_now = true;
            //     });
            
            var request = {
                method: 'GET',
                params: false,
                hasFile: false,
                route: { settings: 'hiring' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        if(parseInt(data.setting_data)){
                            vm.can_apply = true;
                        }
                        // console.log(data);
                        init_processes();
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });
        }

        vm.cannot_register = () => {

            if(vm.data.username && !vm.data.username.includes('@gmail.com')){
                if(vm.data.username && vm.data.kakao_id){
                    return 'gmail'
                }
                return true;
            }

            return !vm.data.username || !vm.data.name || !vm.data.kakao_id;
        }

    }
})();


// WEBPACK FOOTER //
// ./src/app/components/login/login.component.js